// extracted by mini-css-extract-plugin
export default {"textarea":"styles_textarea__1w+yH","textarea--alert":"styles_textarea--alert__AYBj1"};